module.exports = __webpack_public_path__ + "static/media/duskbladesql.19c2d763.svg";